import IndexModel from "@/service/v1/seguranca/IndexModel";
 
class AuditoriaService extends IndexModel {
      
    constructor() {
        super();
        this.url = this.url + '/Auditoria';
    }
 
    public getApiUrl() {
        return this.getAxios().defaults.baseURL + this.url;
    }

    
    public getTipo( ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().get( this.url  + '/GetTipo'   , {}  )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }
    
      
}
  
export default AuditoriaService;

